import { useEffect } from "react";
import { Link } from "react-router-dom";
import BuyProductSection from "../components/buy/BuyProductSection";
import PageMeta from "../components/seo/PageMeta";
import {
  BUY_EMAIL_HREF,
  BUY_HOW_IT_WORKS,
  BUY_PRODUCT_SECTIONS,
  BUY_WHATSAPP_HREF,
} from "../data/buy";
import { buildWebPageJsonLd } from "../lib/seo";
import "../styles/buy.css";

function EnvelopeIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m3 6 9 7 9-7" />
    </svg>
  );
}

function WhatsAppIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8z" />
    </svg>
  );
}

export default function BuyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <article className="buy-page" aria-label="Buy">
      <PageMeta
        title="Buy Prints"
        description="Buy fine art photography prints from CJ Jayamaha — digital files, paper prints, and framed work. Personal ordering by email or WhatsApp."
        path="/buy"
        image="cjmeister-com-_CJ08407.jpg"
        keywords={["buy prints", "fine art photography", "photo prints", "CJ Jayamaha"]}
        jsonLd={buildWebPageJsonLd({
          title: "Buy Photography Prints",
          description:
            "Order photography prints and digital files from CJ Jayamaha by email or WhatsApp.",
          path: "/buy",
          image: "cjmeister-com-_CJ08407.jpg",
        })}
      />
      <header className="buy-page__header">
        <div className="buy-page__eyebrow">AVAILABLE TO BUY</div>
        <h1 className="buy-page__title">Take one home.</h1>
        <p className="buy-page__intro">
          Every photograph here is for sale — as a digital file, a print on lovely
          paper, or framed and ready for a wall. There&rsquo;s no flashy checkout,
          no cart, no &ldquo;customers also bought&rdquo;. Honestly, sales are rare
          enough that a shopping cart would just gather dust. So instead: pick the
          one you love, send me a message, and we&rsquo;ll sort out the details like
          civilised humans.
        </p>
        <div className="buy-page__header-actions">
          <a href={BUY_EMAIL_HREF} className="buy-cta buy-cta--primary">
            <EnvelopeIcon />
            EMAIL ME
          </a>
          <a
            href={BUY_WHATSAPP_HREF}
            className="buy-cta buy-cta--outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            <WhatsAppIcon />
            WHATSAPP
          </a>
        </div>
      </header>

      <div className="buy-page__sections">
        {BUY_PRODUCT_SECTIONS.map((section) => (
          <BuyProductSection key={section.key} section={section} />
        ))}
      </div>

      <section className="buy-how" aria-labelledby="buy-how-heading">
        <div className="buy-how__panel">
          <div id="buy-how-heading" className="buy-how__eyebrow">
            HOW IT WORKS
          </div>
          <div className="buy-how__steps">
            {BUY_HOW_IT_WORKS.map((step) => (
              <div key={step.step} className="buy-how__step">
                <div className="buy-how__step-number">{step.step}</div>
                <div className="buy-how__step-title">{step.title}</div>
                <p className="buy-how__step-copy">{step.copy}</p>
              </div>
            ))}
          </div>
          <div className="buy-how__actions">
            <a href={BUY_EMAIL_HREF} className="buy-cta buy-cta--primary">
              <EnvelopeIcon />
              START AN ORDER
            </a>
            <p className="buy-how__contact-note">
              Questions first? That&rsquo;s what the{" "}
              <Link to="/contact" className="buy-how__contact-link">
                contact page
              </Link>{" "}
              is for.
            </p>
          </div>
        </div>
      </section>
    </article>
  );
}
